// GET COLOR COLOR BY ID
export const getColor = (_id, _template, _default = false) => {

    // check to see if id exists at all
    if(Array.isArray(_template) && _template.length>0){
        _id = (_template.colours.find(item => item.id === _id) || _template.gradients.find(item => item.id === _id)) ? _id : 0;
    }
   
    // id of zero means no colour
    if (_id === 0) {
        return (_default) ? _default : "initial";
    }

    let _f;

    if (_id % 2) {
        // colour
        _f = _template.colours.find(item => item.id === _id);
        return (_f) ? _f.style : "rgba(0, 0, 0, 1)";
    } else {
        // gradient
        _f = _template.gradients.find(item => item.id === _id);
        return (_f) ? _f.style : "rgba(0, 0, 0, 1)";
    }

}

// GET FONT FAMILY BY ID
export const getFontFamily = (font = 1, _template, _last = false) => {
    let _f = _template.fonts.find(item => item.id === font);
    if (_f) {
        return _f.name;
    } else {

        if (_template.base_font && !_last) {
            return getFontFamily(_template.base_font, _template, true);
        } else {
            return 'Default';
        }

    }
}

// GET FONT STYLE BY ID
export const getFontStyle = (fontStyle = 1) => {
    switch (fontStyle) {
        case 1:
            return "normal";
        case 2:
            return "italic";
        case 3:
            return "oblique";
        default:
            return "normal";
    }
}

// GET BOX SHADOW FROM OBJECT
export const getBoxShadow = (boxShadow = { x: 0, y: 0, b: 0, color: 1 }) => {
    return `${boxShadow.x}px ${boxShadow.y}px ${boxShadow.b}px ${getColor(
        boxShadow.color
    )}`;
}

// GET BOX TEXT SHADOW FROM OBJECT
export const getTextShadow = (textShadow = { x: 0, y: 0, b: 0, color: 1 }) => {
    return `text-shadow: ${textShadow.x}px ${textShadow.y}px ${textShadow.b}px ${getColor(
        textShadow.color
    )}`;
}

// GET UNDERLINE FROM OBJECT
export const getUnderline = (underline = { underline: false, color: 1 }) => {
    return `text-decoration: ${underline.underline ? "underline" : "none"
        } ${getColor(underline.color)}`;
}

// GET BORDER FROM OBJECT
export const getBorder = (border = { color: 1, size: 0, left: false, right: false, top: false, border: false, radius: 0 }) => {
    let str = "";
    str += `  border-color: ${getColor(border.color)};\n`;
    str += `  border-width: ${border.size}px;\n`;
    str += `  border-style: solid;\n`;
    str += border.left ? "  border-left-width: 0;\n" : "";
    str += border.top ? "  border-top-width: 0;\n" : "";
    str += border.right ? "  border-right-width: 0;\n" : "";
    str += border.bottom ? "  border-bottom-width: 0;\n" : "";
    str += `  border-radius: ${border.radius}px;\n`;
    return str;
}

export const processKey = (_key = "", _obj = {}) => {
    switch (_key) {
        case "text_align":
            return `  text-align: ${_obj.text_align};\n`;
        case "font":
            return `  font-family: ${getFontFamily(_obj.font)};\n`;
        case "font_size":
            return `  font-size: ${_obj.font_size}px;\n`;
        case "font-style":
            return `  font-style: ${getFontStyle(_obj.font_style)};\n`;
        case "letter_spacing":
            return `  letter-spacing: ${_obj.letter_spacing}px;\n`;
        case "line_height":
            return `  line-height: ${_obj.line_height};\n`;
        case "color":
            return `  color: ${getColor(_obj.color)};\n`;
        case "padding":
            return `  padding: ${_obj.padding.y}px ${_obj.padding.x}px;\n`;
        case "bg_color":
            return `  background-color: ${getColor(_obj.bg_color)};\n`;
        case "bg_shadow":
            return `  box-shadow: ${getBoxShadow(_obj.bg_shadow)};\n`;
        case "border":
            return `${getBorder(_obj.border)};\n`;
        case "text_shadow":
            return `  ${getTextShadow(_obj.text_shadow)};\n`;
        case "underline":
            return `  ${getUnderline(_obj.underline)};\n`;
        default:
            return "";
    }
}

export const getCSS = (_obj, _class = "class") => {
    let css = "";
    css += `.${_class} {\n`;
    Object.keys(_obj).forEach(key => {
        css += processKey(key, _obj[key])
    })
    css += `}\n`;
    return css;
}